import About from "../components/About.jsx"; 
import Header from "../components/Header.jsx"; 
import SubHero from "../components/SubHero"; 
import Staff from "../components/Staff"; 
import Information from "../components/Information"; 
import Questions from "../components/Questions.jsx";
import Footer from "../components/Footer.jsx"; 
const AboutPage = ()=>{
  return (
    <>
      <Header/>
      <SubHero imgUrl = {'https://i.ibb.co/Sv86LfF/aboutimage.jpg'} section = {"About us"} name = {"About officialbillboard"} destination = {"home"}/>
      <Information />
      <About />
      <Staff />
      <Questions />
      <Footer />
    </>
  ); 
}
export default AboutPage; 
